// extracted by mini-css-extract-plugin
export default {"r_l":"_72e1305014 _1b80a3372a","t":"f72797927a"};